angular.module('ikeweb.spike.measure').service('measurementService', ['measurementFactory', 'photogrammetryToolKit',

    function(measurementFactory, photogrammetryToolKit) {

        var Type = photogrammetryToolKit.Measurement.Shape.Types;

        function add(a, b) {
            return a + b;
        }

        function equal(b) {
            return function(a) {
                return a === b;
            };
        }

        function getter(g) {
            return function(data) {
                return data[g]();
            };
        }

        function compareGetter(getter, pred) {
            return function(data) {
                return pred(data[getter]());
            };
        }

        function sumMeasurementData(measurementData, get, type) {
            return measurementData
                .filter(compareGetter('getType', equal(type)))
                .map(getter(get))
                .reduce(add, 0);
        }

        function getAreaTotal(measurements) {
            return sumMeasurementData(measurements, 'getArea', Type.MAIN);
        }

        function getMainArea(measurements) {
            return measurements.filter(compareGetter('getType', equal('main'))).pop();
        }

        function getAreas(measurements) {
            var mainArea = getMainArea(measurements);
            return measurementFactory.create({
                id: 'areasTotal',
                name: 'Area',
                area: getAreaTotal(measurements),
                dimensions: mainArea ? mainArea.getDimensions() : []
            });
        }

        function getCutoutTotal(measurements) {
            return sumMeasurementData(measurements, 'getArea', Type.CUTOUT);
        }

        function getCutouts(measurements) {
            return measurementFactory.create({
                id: 'cutoutsTotal',
                name: 'Cutouts',
                area: getCutoutTotal(measurements)
            });
        }

        function getAreaMinusCutouts(measurements) {
            return measurementFactory.create({
                id: 'areaMinusCutouts',
                name: 'Area - Cutouts',
                area: getAreaTotal(measurements) - getCutoutTotal(measurements)
            });
        }

        function getLineTotal(measurements) {
            return sumMeasurementData(measurements, 'getPerimeter', Type.LINE);
        }

        function getLines(measurements) {
            return measurementFactory.create({
                id: 'lineTotal',
                name: 'Line Sum',
                totalDimension: getLineTotal(measurements)
            });
        }

        function createMeasurements(measurementData) {
            return measurementData.map(measurementFactory.createMeasurement);
        }

        function createMeasurementsFromStorage(measurementData) {
            return [].concat(measurementData.main_polygons, measurementData.cutout_polygons, measurementData.polylines)
                .map(measurementFactory.createMeasurement);
        }

        function getMeasurement(id, measurements) {
            return measurements
                .concat([getAreas(measurements), getCutouts(measurements), getAreaMinusCutouts(measurements), getLines(measurements)])
                .filter(compareGetter('getId', equal(id)))
                .pop();
        }

        return {
            createMeasurements: createMeasurements,
            createMeasurementsFromStorage: createMeasurementsFromStorage,
            getCutouts: getCutouts,
            getAreaMinusCutouts: getAreaMinusCutouts,
            getLines: getLines,
            getAreas: getAreas,
            getMeasurement: getMeasurement
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/measurement/measurement.service.js
// module id = 520
// module chunks = 0